// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JG3K","question":"styles_question__1gWeG","inputVisibleButton":"styles_inputVisibleButton__1Lm6c","note":"styles_note__2sMd2"};